//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from 'vuex';

export default {
  props: {
    value: { type: Boolean, default: false },
    type: { type: String, default: '' },
    data: { type: Array, default: () => ([]) },
  },

  data() {
    return {};
  },

  computed: {
    model: {
      get() {
        const { value } = this;
        return value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },

  methods: {
    ...mapActions('common', [
      'setGeneralProgress',
      'setErrorNotification',
      'setSuccessNotification',
    ]),
  },
};
